
const Nav = () => {
  let $mainMenu = document.querySelector('.main-menu')
  window.addEventListener('scroll', () => {
    $mainMenu.classList.toggle('sticky', window.pageYOffset > 25)
  })

  let $navTrigger = document.querySelector('.nav-trigger'),
      $mobileMenu = document.querySelector('.nav-mobile'),
      $closeMenu  = document.querySelector('.close-menu'),
      $mobileMenuInner = document.querySelector('.nav-mobile__inner-content')

  $navTrigger.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    $navTrigger.classList.toggle('active', !$navTrigger.classList.contains('active'))
    $mobileMenu.classList.toggle('active', $navTrigger.classList.contains('active'))
  })

  document.addEventListener('click', (event) => {
    if(event.target === $mobileMenuInner || $mobileMenuInner.contains(event.target)) {
      event.stopPropagation();
    } else {
      $navTrigger.classList.remove('active')
      $mobileMenu.classList.remove('active')
    }
  })


}
export default Nav
